<template>
  <div>
    <el-input ref="input" :value="value" @input="onInput" @blur="onBlur" />
  </div>
</template>

<script>
import Vue from 'vue'
import { roundHalfUp2 } from '@/utils/NumberUtils'
export default Vue.extend({
  name: 'AccountingDocumentAmountEditor',
  data() {
    return {
      originValue: '',
      value: ''
    }
  },
  created() {
    this.value = this.params.value === 0 ? '' : this.params.value
    this.originValue = this.params.value
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
      }
    })
  },
  methods: {
    getValue() {
      if (Number(this.value) || Number(this.value) === 0) {
        return roundHalfUp2(Number(this.value))
      }
      // 等号
      if (this.value === '=' && this.params.accountingEntrys.length > 0) {
        return this.handleEqualSign(this.value)
      }
      return this.originValue
    },
    // 处理等号
    handleEqualSign(val) {
      let debitTotalNum = 0
      let creditTotalNum = 0
      for (const entry of this.params.accountingEntrys) {
        if (!(entry.index === this.params.accountingEntry.index && entry.uuid === this.params.accountingEntry.uuid)) {
          debitTotalNum += entry.debitAmount
          debitTotalNum = roundHalfUp2(debitTotalNum)
          creditTotalNum += entry.crebitAmount
          creditTotalNum = roundHalfUp2(creditTotalNum)
        }
      }
      const amountDiff = roundHalfUp2(debitTotalNum - creditTotalNum)
      if (amountDiff < 0) {
        this.params.accountingEntry.crebitAmount = 0
        this.params.accountingEntry.debitAmount = amountDiff
      } else if (amountDiff > 0) {
        this.params.accountingEntry.debitAmount = 0
        this.params.accountingEntry.crebitAmount = amountDiff
      }
      return this.params.accountingEntry[this.params.field]
    },
    onInput(val) {
      // 等号
      if (val === '=' && this.params.accountingEntrys.length > 0) {
        this.value = this.handleEqualSign(val)
      } else {
        this.value = val
      }
    },
    onBlur() {
      this.params.api.stopEditing()
    }
  }
})
</script>
